export const SearchCloseIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M6.99998 6C6.74907 6 6.49819 6.09604 6.3069 6.28771L0.287198 12.3222C-0.0957328 12.7061 -0.0957328 13.3285 0.287198 13.7122C0.669975 14.0959 1.29071 14.0959 1.67367 13.7122L6.99998 8.37252L12.3263 13.712C12.7092 14.0957 13.3299 14.0957 13.7127 13.712C14.0958 13.3283 14.0958 12.7059 13.7127 12.3221L7.69306 6.28752C7.50167 6.09582 7.25079 6 6.99998 6Z"
        fill="currentColor"
      />
      <path
        d="M7.00002 8C7.25093 8 7.50181 7.90396 7.6931 7.71229L13.7128 1.67776C14.0957 1.29388 14.0957 0.671503 13.7128 0.287787C13.33 -0.095929 12.7093 -0.095929 12.3263 0.287787L7.00002 5.62748L1.67369 0.287972C1.29076 -0.0957437 0.670084 -0.0957438 0.287338 0.287972C-0.095779 0.671688 -0.0957791 1.29407 0.287338 1.67794L6.30694 7.71248C6.49833 7.90418 6.74921 8 7.00002 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
